import createRemoteObjectResourceReducer from "./helpers/createRemoteObjectResourceReducer";

export const eula = createRemoteObjectResourceReducer("USER_EULA_RESPONSE");
